import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core/styles';
import Quantity from '../../../../../common/Quantity';

function ValueBox(props) {
  const { type, item, newRate } = props;
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const quantity = item.quantity;
  const currentRate = item.adjustedUnitRate ? item.adjustedUnitRate.value : null;
  const unit = item.type.unit;

  const displayRate = type === 'new' && newRate != null && !isNaN(newRate)
    ? newRate
    : currentRate;

  const displayValue = (() => {
    if (displayRate != null && !isNaN(displayRate)) {
      return displayRate * quantity;
    }
    return null;
  })();

  const formattedNum = (num) => {
    if (num == null || isNaN(num)) return '—';
    return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const isNew = type === 'new';
  const borderColor = isDark ? 'rgba(255,255,255,0.1)' : '#e2e8f0';
  const labelColor = isDark ? '#94a3b8' : '#64748b';
  const textColor = isDark ? '#e2e8f0' : '#1e293b';
  const highlight = isNew ? (isDark ? '#6366f1' : '#4f46e5') : undefined;

  return (
    <div
      style={{
        border: `1px solid ${isNew && displayRate != null ? (isDark ? 'rgba(99,102,241,0.3)' : '#c7d2fe') : borderColor}`,
        borderRadius: '16px',
        padding: '16px',
        textAlign: 'center',
        backgroundColor: isNew && displayRate != null
          ? (isDark ? 'rgba(99,102,241,0.06)' : '#f5f3ff')
          : 'transparent',
      }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '1px',
          marginBottom: '12px',
        }}>
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: '11px',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: labelColor,
            marginBottom: '6px',
          }}>
            {isNew ? 'New' : 'Current'} Rate
          </div>
          <div style={{
            fontSize: '16px',
            fontWeight: 500,
            color: isNew && displayRate != null ? highlight : textColor,
          }}>
            {formattedNum(displayRate)} <span style={{ fontSize: '12px', color: labelColor }}>AED/{unit}</span>
          </div>
        </div>
        <div style={{
          width: '1px',
          backgroundColor: borderColor,
          margin: '4px 0',
        }} />
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: '11px',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: labelColor,
            marginBottom: '6px',
          }}>
            Quantity
          </div>
          <div style={{
            fontSize: '16px',
            fontWeight: 500,
            color: textColor,
          }}>
            {formattedNum(quantity)} <span style={{ fontSize: '12px', color: labelColor }}>{unit}</span>
          </div>
        </div>
      </div>
      <div style={{
        borderTop: `1px solid ${borderColor}`,
        paddingTop: '12px',
      }}>
        <div style={{
          fontSize: '11px',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: labelColor,
          marginBottom: '6px',
        }}>
          {isNew ? 'New' : 'Current'} Value
        </div>
        <div style={{
          fontSize: isNew ? '28px' : '18px',
          fontWeight: isNew ? 600 : 500,
          color: isNew && displayValue != null ? highlight : textColor,
        }}>
          {isNew ? (
            <Quantity
              quantitySize={80}
              showUnitLabel={false}
              enableChangeDirAnimation={false}
              inlineUnit
              quantity={displayValue != null ? displayValue : 0}
              style={{ fontSize: '28px' }}
            />
          ) : (
            <span>{formattedNum(displayValue)}</span>
          )}
          {' '}
          <span style={{ fontSize: '14px', color: labelColor }}>AED</span>
        </div>
      </div>
    </div>
  );
}

ValueBox.propTypes = {
  type: PropTypes.oneOf(['current', 'new']),
  item: PropTypes.object.isRequired,
  newRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ValueBox.defaultProps = {
  type: 'current',
};

export default ValueBox;
